<div>
    <app-breadcrumb></app-breadcrumb>
    <div *ngIf="successMessage!=null" class="alert alert-success alert-dismissible fade show ms-4 me-4 p-2" role="alert">
        <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
        <strong class="ps-2">{{successMessage}}</strong>
    </div>
    <div *ngIf="errorMessage!=null" class="alert alert-danger alert-dismissible ms-4 me-4 p-2">
        <button type="button" class="btn-close" (click)="close()" data-bs-dismiss="alert" aria-label="close"></button>
        <strong class="ps-2">{{errorMessage}}</strong>
    </div>
    <h2 class="roboto-medium title ms-4 me-4">Add Event</h2>
</div>


<div class="create-container mt-1">
    <div class="create-form-container ms-4 me-4 mb-5 pb-5">
        <div class="mat-typography content">
            <mat-accordion hideToggle multi>
                <mat-expansion-panel disabled [expanded]="true" #panel class="mat-elevation-z0 ">
                    <mat-expansion-panel-header class="header-container">
                        <mat-panel-title class="roboto-bold me-0 addEventTitle menuType">Add Event</mat-panel-title>
                        <mat-slide-toggle class="roboto-bold addEventTitle" color="primary" [(ngModel)]="checked">Unplanned Route</mat-slide-toggle>
                    </mat-expansion-panel-header>
                    <form [formGroup]="addRouteEventForm" class="alignItem">


                        <div class="row d-flex flex-wrap my-3 align-items-start">

                            <div class="col-md">
                                <div class="row mb-3">
                                    <div class="col-md-4 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col form-group required control-label validRequired" for="eventType">Event Type</label>
                                        <div class="d-block">
                                            <select class="" id="eventType" formControlName="eventType"
                                                [ngClass]="{'is-invalid': submitted && form['eventType'].errors }" (change)="onEventTypeSelection($event)">
                                                <option value="">Please Select</option>
                                                <option *ngFor="let event of eventProbTypeList" [ngValue]="event">
                                                    {{event.eventType}}
                                                </option>
                                            </select>
                                            <div *ngIf="submitted && form['eventType'].errors" class="invalid-feedback">
                                                <div *ngIf="form['eventType'].errors['required']">
                                                    Please Select the Event Type.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col form-group required control-label validRequired" for="plannedUnload">Planned Unload</label>
                                        <div class="d-block">
                                            <input class="form-control" type="date" name="plannedUnload" id="plannedUnload" formControlName="plannedUnload"
                                            [ngClass]="{'is-invalid': submitted && form['plannedUnload'].errors }">
                                            <div *ngIf="submitted && form['plannedUnload'].errors" class="invalid-feedback">
                                                <div *ngIf="form['plannedUnload'].errors['required']">
                                                    Please Select the Planned Unload.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col form-group required control-label validRequired alignLabel"
                                            for="routeName">Route Name</label>
                                        <div class="d-block">
                                            <input class="form-control" type="text" name="routeName" id="routeName" formControlName="routeName"
                                            [ngClass]="{'is-invalid': submitted && form['routeName'].errors }" autocomplete="off">
                                            <div *ngIf="submitted && form['routeName'].errors" class="invalid-feedback">
                                                <div *ngIf="form['routeName'].errors['required']">
                                                    Please enter the Route Name.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col form-group required control-label validRequired" for="status">Status</label>
                                        <div class="d-block">
                                            <select class="" id="status" formControlName="status"
                                                [ngClass]="{'is-invalid': submitted && form['status'].errors }" (change)="statusChange()">
                                                <option value="">Please Select</option>
                                                <option *ngFor="let st of statusList" [ngValue]="st">
                                                    {{st.description}}
                                                </option>
                                            </select>
                                            <div *ngIf="submitted && form['status'].errors" class="invalid-feedback">
                                                <div *ngIf="form['status'].errors['required']">
                                                    Please Select the Status.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col form-group required control-label validRequired" for="problemType">Problem Type</label>
                                        <div class="d-block">
                                            <select class="" id="problemType" formControlName="problemType"
                                                [ngClass]="{'is-invalid': submitted && form['problemType'].errors }">
                                                <option value="">Please Select</option>
                                                <option *ngFor="let event of eventList" [ngValue]="event">
                                                    {{event.description}}
                                                </option>
                                            </select>
                                            <div *ngIf="submitted && form['problemType'].errors" class="invalid-feedback">
                                                <div *ngIf="form['problemType'].errors['required']">
                                                    Please Select the Problem Type.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col form-group required control-label validRequired alignLabel"
                                            for="logisticsPartner">Logistics Partner</label>
                                        <div class="d-block">
                                            <select id="logisticsPartner" formControlName="logisticsPartner"

                                                [ngClass]="{'is-invalid': submitted && form['logisticsPartner'].errors }"
                                                class="">
                                                <option value="">Please Select</option>
                                                <option *ngFor="let lg of logisticPartnerList" [ngValue]="lg">
                                                    {{lg.vendorName}}
                                                </option>
                                            </select>
                                            <div *ngIf="submitted && form['logisticsPartner'].errors" class="invalid-feedback">
                                                <div *ngIf="form['logisticsPartner'].errors['required']">
                                                    Please Select the Logistics Partner.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 form-group eventInput">
                                        <label class="col-lg-3 col-md-6 col control-label" for="incidentDateTime">ETA Date</label>
                                        <div class="d-block">
                                            <input class="form-control" type="date" name="incidentDateTime"
                                            id="incidentDateTime" formControlName="incidentDateTime" (change)="onDateSelection()"
                                          >
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group eventInput">
                                        <label class="col-lg-3 col-md-6 col control-label" for="incidentTime">ETA Time</label>
                                        <div class="d-block">
                                            <ngx-timepicker-field formControlName="incidentTime" class="form-control timepicker" [format]="24" [defaultTime]="'00:00'"></ngx-timepicker-field>
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group eventInput">
                                      <label class="col-lg-3 col-md-6 col form-group control-label alignLabel"
                                          for="trailer">Trailer</label>
                                      <div class="d-block">
                                          <input class="form-control" type="text" name="trailer"
                                          id="trailer" formControlName="trailer" autocomplete="off">
                                      </div>
                                  </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-md-4 form-group required eventInput">
                                        <label class="col-lg-3 col-md-6 col form-group control-label" for="commentsInput">Comments<span *ngIf="commentsRequired" class="commentsReq">*</span></label>
                                        <div class="d-block">
                                            <textarea class="form-control textColor" name="commentsInput" id="commentsInput" cols="30" rows="4"
                                            formControlName="commentsInput" autocomplete="off"
                                            [ngClass]="{'is-invalid': submitted && form['commentsInput'].errors && commentsRequired }"></textarea>
                                            <div *ngIf="submitted && form['commentsInput'].errors && commentsRequired" class="invalid-feedback">
                                                <div *ngIf="form['commentsInput'].errors['required']">
                                                    Please enter the comments.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 form-group  eventInput"></div>

                                    <div class="col-md-4 offset-1 form-group eventInput action">
                                        <button class="cancel me-3 roboto-bold" (click)="onCancel()"> CANCEL </button>
                                        <button class="black-button me-3 roboto-medium " (click)="onSubmit()">SAVE</button>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </form>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
</div>
